module.exports = __webpack_public_path__ + "static/img/5.54812d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/5.png
// module id = 4j+9
// module chunks = 0